var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.053 6.411l1.174-1.175a1.052 1.052 0 111.489 1.489L8.744 9.696a1.052 1.052 0 01-1.488 0L4.284 6.725a1.053 1.053 0 011.489-1.489l1.175 1.175V2.49a1.053 1.053 0 012.104 0v3.921zm3.402 3.359a1.052 1.052 0 012.105 0v3.74c0 .581-.47 1.053-1.052 1.053H2.492A1.052 1.052 0 011.44 13.51V9.77a1.052 1.052 0 012.105 0v2.688h8.91V9.77z"}));
}

Download.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Download;

Download.default = Download;
